<!--
 * @Author: wzh
 * @Date: 2023-03-15 12:43:04
 * @Description: CAS退出
-->
<template>
	<div class=""></div>
</template>

<script>
export default {
	name: "Logout",
	data() {
		return {};
	},
	created() {
		let redirect_uri = this.$route.query.redirect_uri;
		if (redirect_uri) {
			this.logout(redirect_uri);
		}
	},
	methods: {
		logout(redirect_uri) {
			this.$store.dispatch("auth/loginOut", redirect_uri);
		},
	},
};
</script>

<style lang="scss" scoped></style>
